import BasicButton from '../../../../../../Shared/Ui/Buttons/BasicButton/BasicButton';
import css from './DeleteTemplateFromCartWarningModal.module.css';
import { BasicModal } from '@shared/Widgets/Modals/BasicModal/BasicModal';
import classNames from 'classnames';
import React from 'react';

interface DeleteTemplateFromCartWarningModalProps {
    onClose?: () => void;
    onConfirm?: () => void;
    templateTitle?: string;
}

export const DeleteTemplateFromCartWarningModal: React.FC<
    DeleteTemplateFromCartWarningModalProps
> = ({ onClose, templateTitle, onConfirm }) => {
    return (
        <BasicModal onClose={onClose} extraClassName={css.modal}>
            <div className={css.content}>
                <p className={css.warning}>
                    Are you sure you want to delete the "{templateTitle}"
                    template?
                </p>
            </div>
            <div className={css.btns}>
                <BasicButton
                    extraClassName={classNames(css.btn, css.cancel)}
                    onClick={onClose}
                >
                    CANCEL
                </BasicButton>

                <BasicButton extraClassName={css.btn} onClick={onConfirm}>
                    CONFIRM
                </BasicButton>
            </div>
        </BasicModal>
    );
};
